import React, { useState } from "react";
import "./App.css";
import FutureCareerCard from "./components/FutureCareerCard";
import html2canvas from "html2canvas";
import { useRef } from "react";

const API_BASE = "https://aipersonalitychecker.semicoloninnovations.in/api";

function App() {
  const [step, setStep] = useState("welcome");
  const [loading, setLoading] = useState(false);
  const cardRef = useRef(null);

  const downloadCardAsImage = async () => {
    if (!cardRef.current) return;

    const element = cardRef.current;

    const canvas = await html2canvas(element, {
      scale: 2,
      useCORS: true,
      backgroundColor: null,
    });

    const dataURL = canvas.toDataURL("image/png");

    // Create a download link
    const link = document.createElement("a");
    link.href = dataURL;
    link.download = `${fullName.replace(" ", "_")}_CareerBadge.png`;
    link.click();
  };

  // User info
  const [fullName, setFullName] = useState("");
  const [phone, setPhone] = useState("");
  const [userId, setUserId] = useState(null);
  const [errors, setErrors] = useState({});

  // Questions
  const [currentIndex, setCurrentIndex] = useState(0);
  const [answers, setAnswers] = useState({});

  // AI result
  const [aiResult, setAiResult] = useState(null);

  // Questions list (you can expand later)
  const questions = [
    {
      id: "q1",
      text: "Which area interests you the most?",
      options: [
        // --- IT & TECH FIELDS ---
        "Web Development",
        "Mobile App Development",
        "AI / Machine Learning",
        "UI/UX & Creative Design",
        "Cyber Security",
        "Data Science & Analytics",
        "Cloud Computing & DevOps",
        "Game Development",
        "AR / VR & 3D Technologies",
        "IoT / Robotics / Embedded Systems",
        "Blockchain & Web3",

        // --- NON-IT FIELDS ---
        "Business & Management",
        "Finance & Accounting",
        "Human Resources (HR)",
        "Sales & Marketing",
        "Entrepreneurship / Startup Building",

        // --- ARTS & CREATIVE ---
        "Fine Arts",
        "Performing Arts (Dance / Music / Theatre)",
        "Graphic Design",
        "Photography / Videography",
        "Animation / VFX / Motion Graphics",
        "Content Creation / Social Media",
        "Interior Design",
        "Fashion Design",

        // --- SCIENCE & RESEARCH ---
        "Biotechnology",
        "Biochemistry",
        "Microbiology",
        "Chemistry / Physics Research",
        "Mathematics / Statistics",
        "Environmental Science",
        "Agricultural Science",
        "Psychology & Behavioural Science",

        // --- HEALTH & MEDICAL ---
        "Nursing",
        "Pharmacy",
        "Medical / Paramedical Studies",
        "Public Health",

        // --- EDUCATION / SOCIAL SECTOR ---
        "Teaching & Training",
        "Civil Services / Government Career",
        "Social Work",
        "Law & Legal Studies",

        // --- OTHER INTERESTS ---
        "Hospitality & Tourism",
        "Aviation",
        "Sports & Fitness",
        "Culinary Arts",
        "Other"
      ],
    },

    {
      id: "q2",
      text: "How do you prefer learning?",
      options: [
        "Videos & Visual Content",
        "Documentation & Blogs",
        "Hands-on Practice",
        "Mentorship / Classes",
        "Project-Based Learning",
        "Self-Paced Online Courses",
        "Group Learning / Workshops"
      ],
    },

    {
      id: "q3",
      text: "What is your current education status?",
      options: [
        "School Student (8–10)",
        "School Student (11–12)",
        "Diploma Student",
        "Undergraduate (B.Tech / BE)",
        "Undergraduate (B.Sc / BCA)",
        "Undergraduate (B.Com / BBA)",
        "Postgraduate (M.Tech / ME)",
        "Postgraduate (M.Sc / MCA)",
        "Postgraduate (MBA / M.Com)",
        "Working Professional (IT)",
        "Working Professional (Non-IT)",
        "Other"
      ],
    },

    // NEW QUESTIONS -----------------------------------------------------

    {
      id: "q4",
      text: "Which course category best matches your background?",
      options: [
        "Engineering (CSE / IT)",
        "Engineering (ECE / EEE / Mech / Civil)",
        "Computer Applications (BCA / MCA)",
        "Science (Physics / Chemistry / Math / Biology)",
        "Life Sciences (Biotechnology / Biochemistry / Microbiology)",
        "Commerce (B.Com / M.Com)",
        "Business (BBA / MBA)",
        "Arts & Humanities",
        "Diploma (Polytechnic)",
        "Vocational Courses",
        "Other"
      ],
    },

    {
      id: "q5",
      text: "What type of skills are you planning to improve?",
      options: [
        "Technical Skills (Coding, Software Development)",
        "Creative Skills (Design, Animation, Video Editing)",
        "Analytical Skills (Data, Research, Problem Solving)",
        "Professional Skills (Communication, Management)",
        "Hardware / Electronics Skills",
        "Career Preparation (Aptitude, Interview Skills)"
      ],
    },

    {
      id: "q6",
      text: "What is your goal after completing the course?",
      options: [
        "Get a Job in IT",
        "Switch Career to IT",
        "Start Freelancing",
        "Build My Own Startup",
        "Improve Academic Knowledge",
        "Upskill for Current Job",
        "Explore New Opportunities"
      ],
    },

    {
      id: "q7",
      text: "Which domain would you like guidance about?",
      options: [
        "Software Development",
        "Artificial Intelligence",
        "Cyber Security",
        "Cloud Computing",
        "Data Analytics",
        "Mechanical / Electrical Engineering Careers",
        "Biotech / Biochemistry / Life Sciences Paths",
        "Commerce & Finance Careers",
        "Design & Creative Fields",
        "Government Exams",
        "Research & Higher Studies"
      ],
    }
  ];


  /* ---------------------------------------------------
     VALIDATE USER INFO
  --------------------------------------------------- */
  const validateUser = () => {
    const e = {};
    if (!fullName.trim()) e.fullName = "Full name is required";
    if (!phone.trim() || phone.length < 10)
      e.phone = "Enter a valid phone number";

    setErrors(e);
    return Object.keys(e).length === 0;
  };

  /* ---------------------------------------------------
     API 1: SAVE USER INFO
  --------------------------------------------------- */
  const saveUser = async () => {
    if (!validateUser()) return;

    setLoading(true);
    try {
      const res = await fetch(`${API_BASE}/save-user.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ fullName, phone }),
      });

      const data = await res.json();
      setLoading(false);

      if (data.status === "success") {
        setUserId(data.user_id);
        setStep("questions");
      } else {
        alert("Error: " + data.message);
      }
    } catch (err) {
      setLoading(false);
      alert("Network or server error while saving user.");
    }
  };

  /* ---------------------------------------------------
     API 2: SUBMIT ANSWERS TO AI
  --------------------------------------------------- */
  const submitAnswers = async () => {
    setLoading(true);
    try {
      const payload = { user_id: userId, answers };

      const res = await fetch(`${API_BASE}/analyze-answers.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await res.json();
      setLoading(false);

      if (data.status === "success") {
        setAiResult(data.result);
        setStep("results");
      } else {
        alert("Error analyzing results.");
      }
    } catch (err) {
      setLoading(false);
      alert("Network or AI server error.");
    }
  };

  /* ---------------------------------------------------
     QUESTION FLOW HANDLING
  --------------------------------------------------- */
  const handleSelect = (qid, opt) => {
    setAnswers((prev) => ({ ...prev, [qid]: opt }));
  };

  const handleNext = () => {
    if (currentIndex < questions.length - 1) {
      setCurrentIndex((prev) => prev + 1);
    } else {
      submitAnswers();
    }
  };

  /* ---------------------------------------------------
     UI RENDERING
  --------------------------------------------------- */
  return (
    <div className="main-wrapper">
      <div className="app-card">
        {loading && <div className="loading-screen">Processing...</div>}

        {/* --------------------------------------------------- */}
        {/* WELCOME SCREEN */}
        {/* --------------------------------------------------- */}
        {step === "welcome" && (
          <div className="page">
            <h1 className="title">AI Career Personality Checker</h1>
            <p className="subtitle">
              Discover your ideal tech career based on your personality and
              interests.
            </p>

            <ul className="features-list">
              <li>AI-powered personality insights</li>
              <li>Career recommendations tailored to you</li>
              <li>Upskill course suggestions</li>
            </ul>

            <button className="primary-btn" onClick={() => setStep("user")}>
              Get Started
            </button>
          </div>
        )}

        {/* --------------------------------------------------- */}
        {/* USER DETAILS */}
        {/* --------------------------------------------------- */}
        {step === "user" && (
          <div className="page">
            <h2 className="page-title">Your Details</h2>

            <div className="input-group">
              <label>Full Name</label>
              <input
                value={fullName}
                onChange={(e) => setFullName(e.target.value)}
                placeholder="Enter your name"
              />
              {errors.fullName && (
                <span className="error-text">{errors.fullName}</span>
              )}
            </div>

            <div className="input-group">
              <label>Phone Number</label>
              <input
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                placeholder="Enter phone number"
              />
              {errors.phone && (
                <span className="error-text">{errors.phone}</span>
              )}
            </div>

            <button className="primary-btn" onClick={saveUser}>
              Start Test
            </button>
            <button className="secondary-btn" onClick={() => setStep("welcome")}>
              Back
            </button>
          </div>
        )}

        {/* --------------------------------------------------- */}
        {/* QUESTIONS PAGE */}
        {/* --------------------------------------------------- */}
        {step === "questions" && (
          <div className="page">
            <h2 className="page-title">
              Question {currentIndex + 1}/{questions.length}
            </h2>

            <p className="question-text">{questions[currentIndex].text}</p>

            <div className="options-box">
              {questions[currentIndex].options.map((opt) => (
                <button
                  key={opt}
                  className={`option-btn ${answers[questions[currentIndex].id] === opt
                    ? "selected"
                    : ""
                    }`}
                  onClick={() => handleSelect(questions[currentIndex].id, opt)}
                >
                  {opt}
                </button>
              ))}
            </div>

            <button
              className="primary-btn"
              disabled={!answers[questions[currentIndex].id]}
              onClick={handleNext}
            >
              {currentIndex === questions.length - 1
                ? "Submit"
                : "Next"}
            </button>
          </div>
        )}

        {/* --------------------------------------------------- */}
        {/* AI RESULT SCREEN */}
        {/* --------------------------------------------------- */}
        {step === "results" && aiResult && (
          <div className="page">
            <h2 className="page-title">Your Personalized Career Identity Card</h2>

            <div ref={cardRef} id="careerCardCapture">
              <FutureCareerCard
                name={fullName}
                futureCareer={aiResult.careers?.[0] || "Future Professional"}
                personality={aiResult.personality || "Dynamic Learner"}
                strengths={aiResult.strengths || ["Critical Thinker", "Fast Learner"]}
                badges={aiResult.badges || ["Problem Solver", "Creative Thinker", "Team Player"]}
                recommendedCourse={aiResult.courses?.[0] || "Recommended Course Coming Soon"}
              />
            </div>


            <button
              className="primary-btn"
              style={{ marginTop: "20px" }}
              onClick={downloadCardAsImage}
            >
              Share My Career Badge
            </button>
          </div>
        )}

      </div>
    </div>
  );
}

export default App;
